// extracted by mini-css-extract-plugin
module.exports = {"loader":"DotProgress-module__loader___3_OEW","shadowPulse":"DotProgress-module__shadowPulse___eUgVZ"};